import {
  DocumentInvestor,
  LinkMedia,
  LinkType,
  MediaPress,
  PressRelease,
} from '@lglp/prismic-client';
import { fileExtension, fileSize, FileSizeThresh } from '@lglp/utils';
import { RichTextBlock } from 'prismic-richtext';
import { allPass, anyPass, compose, defaultTo, not, Pred, propEq } from 'ramda';

import { pathEq } from './compact';

export const VIDEO = 'video';
export const IMAGE = 'image';
export const AUDIO = 'audio';
export const TEXT = 'text';
export const QUOTE = 'quote';

export const linkFileExtension = (link: LinkMedia): string => {
  const extension = fileExtension(link?.url || '');
  return extension ? extension.replace('.', '') : '';
};

export const linkFileSize = (link: LinkMedia, lang: string) =>
  fileSize(parseInt(link?.size) || 0, lang, FileSizeThresh.Decimal);

export const fileInfo = (link: LinkMedia, lang: string) =>
  [linkFileExtension(link), link?.size && linkFileSize(link, lang)]
    .filter(Boolean)
    .join(' - ');

/**
 * @deprecated
 */
export const hasTranscription: (data: RichTextBlock[]) => boolean = compose(
  not,
  anyPass([
    allPass([propEq('length', 1), pathEq('0.text', '') as Pred]),
    propEq('length', 0),
  ]),
  defaultTo([])
);

export const getInvestorsDocumentsFromDocument = (
  document: MediaPress | PressRelease | DocumentInvestor
): DocumentInvestor[] | null => {
  const investorDocuments = [];
  if (document.link?.linkType === LinkType.Media)
    investorDocuments.push({
      link: document.link,
      title: document.title,
    });
  if (
    (document as MediaPress).link2?.linkType === LinkType.Media &&
    (document as MediaPress).link2 &&
    (document as MediaPress).title2
  ) {
    investorDocuments.push({
      link: (document as MediaPress).link2,
      title: (document as MediaPress).title2,
    });
  }

  if (investorDocuments.length > 0) {
    return investorDocuments;
  } else {
    return null;
  }
};
